import './Spoiler.css';
import React from 'react';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconPlus } from '../../../resources/icons/IconPlus.svg';
import { ReactComponent as IconMinus } from '../../../resources/icons/IconMinus.svg';
import { get } from '../../../utils';
var Spoiler = function Spoiler(props) {
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary') || "#035E88";
  var variables = {
    '--spoiler-main-color': primaryPageThemeColor,
    '--spoiler-minus-color': "#6E2B62"
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables
  }, /*#__PURE__*/React.createElement("details", {
    onToggle: function onToggle(e) {
      return props.onToggle && props.onToggle(e.currentTarget.open);
    },
    className: "spoiler"
  }, /*#__PURE__*/React.createElement("summary", {
    className: "spoiler__title"
  }, props.title, /*#__PURE__*/React.createElement(IconMinus, {
    className: "spoiler__icon spoiler__icon-minus"
  }), /*#__PURE__*/React.createElement(IconPlus, {
    className: "spoiler__icon spoiler__icon-plus"
  })), /*#__PURE__*/React.createElement("div", {
    className: "spoiler__description"
  }, props.children)));
};
export default Spoiler;
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "czeah23";
var rtlStyles = "r1akvzoo";
var ltrStyles = "llxo574";